/* Sneakers Storefront — theme behaviour
   Vanilla JS, no dependencies. Every widget degrades to working HTML if JS fails. */
(function () {
  'use strict';

  var routes = window.routes || {};
  var strings = window.themeStrings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------ *
   * Overlay + panel plumbing
   * ------------------------------------------------------------------ */

  var openPanels = [];

  function showOverlay() {
    var ov = $('[data-overlay]');
    if (ov) ov.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function hideOverlay() {
    var ov = $('[data-overlay]');
    if (ov) ov.hidden = true;
    document.body.style.overflow = '';
  }

  function openPanel(el) {
    if (!el) return;
    el.setAttribute('data-open', 'true');
    if (openPanels.indexOf(el) === -1) openPanels.push(el);
    showOverlay();
    var focusable = el.querySelector('button, [href], input, select, textarea');
    if (focusable) focusable.focus();
  }

  function closePanel(el) {
    if (!el) return;
    el.setAttribute('data-open', 'false');
    openPanels = openPanels.filter(function (p) { return p !== el; });
    if (!openPanels.length) hideOverlay();
  }

  function closeAllPanels() {
    openPanels.slice().forEach(closePanel);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) {
      e.preventDefault();
      openPanel($('#' + opener.getAttribute('data-panel-open')));
      return;
    }
    var closer = e.target.closest('[data-panel-close]');
    if (closer) {
      e.preventDefault();
      closePanel(closer.closest('[data-panel]'));
      return;
    }
    if (e.target.matches('[data-overlay]')) closeAllPanels();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  /* ------------------------------------------------------------------ *
   * Cart
   * ------------------------------------------------------------------ */

  function refreshCartUI() {
    return fetch(routes.cart_url ? routes.cart_url + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer-content]');
        var current = $('[data-cart-drawer-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () { /* leave the DOM untouched on failure */ });
  }

  function addToCart(payload, button) {
    var original = button ? button.textContent : null;
    if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = '…'; }

    return fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'error');
        return refreshCartUI().then(function () {
          var drawer = $('#CartDrawer');
          if (drawer && drawer.getAttribute('data-cart-type') === 'drawer') openPanel(drawer);
          else window.location.href = '/cart';
        });
      })
      .catch(function (err) {
        var box = button ? button.closest('form') : null;
        var errEl = box ? box.querySelector('[data-form-error]') : null;
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
        else window.alert(err.message);
      })
      .then(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.textContent = original; }
      });
  }

  // Product / quick-add forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var errEl = form.querySelector('[data-form-error]');
    if (errEl) errEl.hidden = true;
    if (!idField || !idField.value) {
      if (errEl) { errEl.textContent = strings.selectSize || 'Sélectionne une taille'; errEl.hidden = false; }
      return;
    }
    addToCart(
      { items: [{ id: Number(idField.value), quantity: Number(qtyField ? qtyField.value : 1) }] },
      form.querySelector('[data-add-button]')
    );
  });

  // Quantity steppers + line item removal (cart drawer and cart page)
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = step.parentNode.querySelector('input');
      var next = Number(input.value) + Number(step.getAttribute('data-qty-step'));
      input.value = Math.max(Number(input.min || 0), next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      updateLine(remove.getAttribute('data-line-remove'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    updateLine(input.getAttribute('data-line-qty'), Number(input.value));
  });

  function updateLine(line, quantity) {
    return fetch(routes.cart_change_url || '/cart/change', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    })
      .then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
        else refreshCartUI();
      });
  }

  /* ------------------------------------------------------------------ *
   * Product variants
   * ------------------------------------------------------------------ */

  function initVariantPicker(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idField = root.querySelector('[name="id"]');
    var button = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price-target]');
    var gallery = document.querySelector('[data-gallery]');

    function currentSelection() {
      return $$('[data-option-index]', root)
        .filter(function (input) { return input.checked; })
        .sort(function (a, b) {
          return Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index'));
        })
        .map(function (input) { return input.value; });
    }

    function findVariant(selection) {
      return variants.filter(function (v) {
        return v.options.length === selection.length && v.options.every(function (opt, i) { return opt === selection[i]; });
      })[0];
    }

    function markAvailability(selection) {
      // For each option group, disable values that yield no purchasable variant
      $$('[data-option-index]', root).forEach(function (input) {
        var index = Number(input.getAttribute('data-option-index'));
        var probe = selection.slice();
        probe[index] = input.value;
        var match = variants.filter(function (v) {
          return v.options[index] === input.value &&
            probe.every(function (val, i) { return i === index || !val || v.options[i] === val; });
        });
        var sellable = match.some(function (v) { return v.available; });
        input.disabled = !sellable;
      });
    }

    function update() {
      var selection = currentSelection();
      markAvailability(selection);

      var variant = findVariant(selection);

      $$('[data-option-selected-for]', root).forEach(function (label) {
        var idx = Number(label.getAttribute('data-option-selected-for'));
        label.textContent = selection[idx] || '';
      });

      if (!variant) {
        if (idField) idField.value = '';
        if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = strings.unavailable || 'Indisponible'; }
        return;
      }

      if (idField) idField.value = variant.id;

      if (button) {
        if (variant.available) {
          button.removeAttribute('aria-disabled');
          button.textContent = strings.addToCart || 'Ajouter au panier';
        } else {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = strings.soldOut || 'Épuisé';
        }
      }

      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;

      if (gallery) filterGalleryByColor(gallery, selection, root);

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) update();
    });

    update();
  }

  $$('[data-variant-picker]').forEach(initVariantPicker);

  /* ------------------------------------------------------------------ *
   * Product gallery
   * ------------------------------------------------------------------ */

  /* The gallery shows every photo of every colourway. Selecting a colour
     narrows it to that colourway; if nothing matches we keep everything
     visible rather than showing an empty grid. */
  function filterGalleryByColor(gallery, selection, root) {
    var colorIndex = -1;
    $$('.option', root).forEach(function (opt) {
      var label = opt.querySelector('.option__label');
      if (!label) return;
      if (/couleur|color|coloris/i.test(label.textContent)) {
        var input = opt.querySelector('[data-option-index]');
        if (input) colorIndex = Number(input.getAttribute('data-option-index'));
      }
    });
    if (colorIndex < 0) return;

    var wanted = selection[colorIndex];
    if (!wanted) return;

    var items = $$('[data-gallery-color]', gallery);
    if (!items.length) return;

    var matches = items.filter(function (el) {
      return el.getAttribute('data-gallery-color') === wanted;
    });

    items.forEach(function (el) {
      el.hidden = matches.length > 0 && matches.indexOf(el) === -1;
    });

    gallery.scrollTo && gallery.scrollTo({ left: 0, behavior: 'smooth' });
  }

  /* ------------------------------------------------------------------ *
   * Collection facets — submit on change, keep it progressive
   * ------------------------------------------------------------------ */

  $$('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      if (form.hasAttribute('data-facet-manual')) return;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  // Filtre de recherche à l'intérieur d'un groupe de facettes
  $$('[data-facet-search]').forEach(function (input) {
    var group = input.closest('.facets__group');
    if (!group) return;
    var items = $$('[data-facet-value]', group);

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      items.forEach(function (li) {
        li.hidden = q !== '' && li.getAttribute('data-facet-value').indexOf(q) === -1;
      });
    });
  });

  $$('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ------------------------------------------------------------------ *
   * Header search toggle
   * ------------------------------------------------------------------ */

  $$('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = $('#SearchPanel');
      if (!panel) return;
      var isOpen = panel.getAttribute('data-open') === 'true';
      if (isOpen) closePanel(panel);
      else openPanel(panel);
    });
  });

  /* ------------------------------------------------------------------ *
   * Motion — every effect below is skipped when the OS asks for less
   * ------------------------------------------------------------------ */

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal sections as they enter the viewport
  (function initReveal() {
    var targets = $$('[data-reveal]');
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    targets.forEach(function (el) {
      $$('.product-grid > li', el).forEach(function (li, i) {
        li.style.setProperty('--i', Math.min(i, 12));
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (el) { io.observe(el); });
  })();

  // Fade images in once they have actually decoded
  (function initImageFade() {
    function mark(img) { img.classList.add('is-loaded'); }
    $$('.card__media img, .tile img, .pgal__item img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) mark(img);
      else img.addEventListener('load', function () { mark(img); }, { once: true });
      img.addEventListener('error', function () { mark(img); }, { once: true });
    });
  })();

  // Compact the header once the page scrolls
  (function initHeaderShrink() {
    var header = $('#SiteHeader');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  })();

  /* ------------------------------------------------------------------ *
   * Product carousels
   * ------------------------------------------------------------------ */

  $$('[data-carousel]').forEach(function (root) {
    var track = $('[data-carousel-track]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);
    if (!track) return;

    function step() {
      var card = track.querySelector('li');
      return card ? card.getBoundingClientRect().width + 8 : 240;
    }

    function sync() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step() * 2; });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step() * 2; });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  });

  /* ------------------------------------------------------------------ *
   * Recently viewed — stored locally, nothing leaves the browser
   * ------------------------------------------------------------------ */

  (function initRecentlyViewed() {
    var KEY = 'recently-viewed';
    var MAX = 12;

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* quota */ }
    }

    var selfEl = $('[data-recent-self]');
    var wrap = $('[data-recent]');
    var track = $('[data-recent-track]');

    var current = null;
    if (selfEl) {
      try { current = JSON.parse(selfEl.textContent); } catch (e) { current = null; }
    }

    var list = read();

    // Render the previously seen ones (excluding the product being viewed)
    if (wrap && track) {
      var others = list.filter(function (p) { return !current || p.handle !== current.handle; });
      if (others.length) {
        track.innerHTML = others.map(function (p) {
          return '<li><div class="card">' +
            '<a class="card__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
              (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" class="is-loaded">' : '') +
            '</a>' +
            '<div class="card__body">' +
              (p.vendor ? '<span class="card__vendor">' + p.vendor + '</span>' : '') +
              '<h3 class="card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
              '<div class="card__price"><span class="price"><span class="price__now">' + p.price + '</span></span></div>' +
            '</div></div></li>';
        }).join('');
        wrap.hidden = false;
      }
    }

    // Record the current product last, so it does not show on its own page
    if (current && current.handle) {
      list = list.filter(function (p) { return p.handle !== current.handle; });
      list.unshift(current);
      write(list);
    }
  })();

  // Mobile navigation: sliding panel stack (level 1 -> 2 -> 3, with a back step).
  (function initMobileNav() {
    var nav = $('#MobileNav');
    if (!nav) return;

    var viewport = $('[data-mnav-viewport]', nav);
    var backBtn = $('[data-mnav-back]', nav);
    var backLabel = $('[data-mnav-back-label]', nav);
    var title = $('[data-mnav-title]', nav);
    if (!viewport) return;

    var panels = {};
    $$('[data-mnav-panel]', nav).forEach(function (p) {
      panels[p.getAttribute('data-mnav-panel')] = p;
    });

    var stack = ['root'];

    function render() {
      var current = stack[stack.length - 1];

      Object.keys(panels).forEach(function (key) {
        var p = panels[key];
        p.classList.toggle('is-active', key === current);
        p.classList.toggle('is-behind', stack.indexOf(key) > -1 && key !== current);
      });

      if (stack.length > 1) {
        var parentKey = stack[stack.length - 2];
        var parentLabel = parentKey === 'root'
          ? (title ? title.getAttribute('data-home-label') || '' : '')
          : (panels[parentKey] ? panels[parentKey].getAttribute('data-mnav-label') : '');

        backBtn.hidden = false;
        backLabel.textContent = parentLabel || panels[current].getAttribute('data-mnav-label') || '';
        if (title) title.hidden = true;
      } else {
        backBtn.hidden = true;
        if (title) title.hidden = false;
      }

      var active = panels[current];
      if (active) active.scrollTop = 0;
    }

    // Remember the store name so the back button can say "back to <store>"
    if (title) title.setAttribute('data-home-label', title.textContent.trim());

    nav.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-mnav-to]');
      if (opener) {
        e.preventDefault();
        var key = opener.getAttribute('data-mnav-to');
        if (panels[key]) { stack.push(key); render(); }
        return;
      }
      if (e.target.closest('[data-mnav-back]')) {
        e.preventDefault();
        if (stack.length > 1) { stack.pop(); render(); }
      }
    });

    // Reopening the drawer always starts from the top level
    var observer = new MutationObserver(function () {
      if (nav.getAttribute('data-open') !== 'true' && stack.length > 1) {
        stack = ['root'];
        render();
      }
    });
    observer.observe(nav, { attributes: true, attributeFilter: ['data-open'] });

    render();
  })();

  // Footer columns: accordions on mobile, always open on desktop.
  // The `open` attribute is HTML state, so CSS alone cannot do this.
  (function initFooterAccordions() {
    var accordions = $$('.footer__acc');
    if (!accordions.length) return;

    var mq = window.matchMedia('(max-width: 749px)');

    function apply() {
      accordions.forEach(function (el) {
        if (mq.matches) el.removeAttribute('open');
        else el.setAttribute('open', '');
      });
    }

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  })();

  // Mega menu: hover is CSS-only; this adds keyboard + touch support
  (function initMegaMenu() {
    $$('.nav__item--has-children').forEach(function (item) {
      var trigger = item.querySelector('.nav__link');
      var panel = item.querySelector('.mega, .nav__panel');
      if (!trigger || !panel) return;

      function setExpanded(v) { trigger.setAttribute('aria-expanded', v ? 'true' : 'false'); }

      item.addEventListener('focusin', function () { setExpanded(true); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setExpanded(false);
      });
      item.addEventListener('mouseenter', function () { setExpanded(true); });
      item.addEventListener('mouseleave', function () { setExpanded(false); });

      // On touch devices the first tap opens the panel instead of following the link
      trigger.addEventListener('click', function (e) {
        if (!window.matchMedia('(hover: none)').matches) return;
        if (trigger.getAttribute('aria-expanded') !== 'true') {
          e.preventDefault();
          setExpanded(true);
          item.classList.add('is-open');
        }
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { setExpanded(false); trigger.focus(); }
      });
    });
  })();
})();
